"use client";
import { jsxs as o, jsx as e } from "react/jsx-runtime";
import _ from "../../../elements/AuthorByline/AuthorByline.js";
import l from "../../../layout/Container/Container.js";
import { Group as c, Paragraph as s, Heading as f, Link as h, Icon as y, Image as b } from "@ingeniorforeningen/figurine-core";
import { forwardRef as w } from "react";
import '../../../../assets/PageTopArticle.css';const P = "_root_192x1_2", A = "_image_192x1_6", k = "_byline_192x1_14", N = "_teaser_192x1_21", i = {
  root: P,
  image: A,
  byline: k,
  teaser: N
}, m = w((p, d) => {
  const { title: g, teaser: a, image: t, editLink: r, subject: x, authorByline: n, articleType: u } = p;
  return /* @__PURE__ */ o(
    c,
    {
      ref: d,
      className: i.root,
      wrap: "nowrap",
      direction: "column",
      p: 0,
      pt: "lg",
      children: [
        /* @__PURE__ */ e(
          s,
          {
            variant: "link",
            text: x,
            transform: "uppercase",
            medium: !0,
            lineClamp: 1,
            condensed: !0,
            align: "center",
            mt: "md"
          }
        ),
        /* @__PURE__ */ o(c, { spacing: "md", align: "center", wrap: "nowrap", direction: "column", children: [
          /* @__PURE__ */ e(f, { type: "h1", text: g, align: "center" }),
          r && /* @__PURE__ */ e(h, { href: r, target: "_blank", children: /* @__PURE__ */ e(y, { name: "Edit", size: "xl" }) })
        ] }),
        a && /* @__PURE__ */ e(l, { children: /* @__PURE__ */ e(
          s,
          {
            text: a,
            align: "center",
            variant: "dark",
            medium: !0,
            className: i.teaser
          }
        ) }),
        t && /* @__PURE__ */ e(
          b,
          {
            ...t,
            caption: t.caption,
            captionAlign: "left",
            byline: t.byline,
            orientation: "landscape",
            width: "100%",
            sizes: "(max-width: 62em) 95vw, 1140px",
            className: i.image
          }
        ),
        n && /* @__PURE__ */ e(l, { size: "sm", mt: "xl", pt: "xl", className: i.byline, children: /* @__PURE__ */ e(_, { ...n, noPrefix: u === "Podcast" }) })
      ]
    }
  );
});
m.displayName = "ArticlePageTop";
const C = m;
export {
  m as _PageTopArticle,
  C as default
};
